<template>
  <div id="privatePage">
    <div v-show="!logged">
      Page avec contenu secret<br>
      <button @click="login">Me connecter</button>
    </div>
    <div v-show="logged">
      Les chaussettes de l'archiduchesse sont blanches.<br>
      <button @click="logout">Me déconnecter</button>
    </div>
    <div>
      <button @click="check">Vérifier</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PrivatePage',
  components: {
  },

  data: () => ({
    logged: false
  }),

  props: {
  },

  methods: {
    login() {
      window.open(window.location.href.split(this.$route.fullPath)[0] + '/redirectSSO',"Connexion","menubar=no, status=no, scrollbars=no, menubar=no, width=500, height=100")
    },
    logout() {
      window.open(window.location.href.split(this.$route.fullPath)[0] + '/redirectSSO?logout=true',"Connexion","menubar=no, status=no, scrollbars=no, menubar=no, width=500, height=100")
    },
    check() {
      this.logged = (window.localStorage.getItem('token') !== null);
    }
  },

  mounted() {
    this.check();
  },

  computed: {
  }
}
</script>

<style>
</style>